if (!window.__missenceAnnouncementMarquee) {
  window.__missenceAnnouncementMarquee = true;
  const marqueeObservers = new Map();

  const updateMarqueeDuration = (marquee, track) => {
    const speed = Number(marquee.dataset.missenceMarqueeSpeed);
    const distance = track.scrollWidth / 2;
    if (!speed || !distance) return;

    track.style.setProperty('--missence-marquee-duration', `${distance / speed}s`);
  };

  const initMarquees = (scope = document) => {
    scope.querySelectorAll('[data-missence-marquee]').forEach((marquee) => {
      const track = marquee.querySelector('[data-missence-marquee-track]');
      if (!track) return;

      marqueeObservers.get(marquee)?.disconnect();
      updateMarqueeDuration(marquee, track);

      if (!('ResizeObserver' in window)) return;
      const observer = new ResizeObserver(() => updateMarqueeDuration(marquee, track));
      observer.observe(track);
      marqueeObservers.set(marquee, observer);
    });
  };

  const destroyMarquees = (scope) => {
    marqueeObservers.forEach((observer, marquee) => {
      if (!scope.contains(marquee)) return;
      observer.disconnect();
      marqueeObservers.delete(marquee);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMarquees());
  } else {
    initMarquees();
  }

  document.addEventListener('shopify:section:load', (event) => initMarquees(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyMarquees(event.target));
}
